import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { PaymentMethod } from '../../loan/Payments';
import { Checkbox, DateString, NonNegativeMonetaryValue } from '../fields';

const BulkDepositMethod = z.enum([
  PaymentMethod.enum.check,
  PaymentMethod.enum.wire,
  PaymentMethod.enum.phone,
  PaymentMethod.enum.lockbox,
  PaymentMethod.enum.reserve,
]);

const BulkDepositBalanceType = z.enum(['Escrow', 'Holdback', 'Loss Draft', 'Unapplied Suspense']);

export const BulkDepositRow = z
  .object({
    loanId: LosId,
    depositDate: DateString,
    depositPayerName: z.string(),
    depositMethod: BulkDepositMethod.default('check'),
    depositAmount: NonNegativeMonetaryValue,
    depositBalanceType: BulkDepositBalanceType,
    interestOnEscrowFlag: Checkbox.optional(),
    startOfNextAccrualPeriod: DateString.optional(),
    flag1099Int: Checkbox.optional(),
  })
  .superRefine((data, ctx) => {
    if (data.interestOnEscrowFlag) {
      if (data.depositBalanceType !== 'Escrow') {
        ctx.addIssue({
          code: 'custom',
          message: 'DEPOSIT_BALANCE_TYPE must be Escrow when INTEREST_ON_ESCROW_FLAG is yes',
          path: ['depositBalanceType'],
        });
      }
      if (!data.startOfNextAccrualPeriod) {
        ctx.addIssue({
          code: 'custom',
          message: 'START_OF_NEXT_ACCRUAL_PERIOD is required when INTEREST_ON_ESCROW_FLAG is yes',
          path: ['startOfNextAccrualPeriod'],
        });
      }
    }

    if (!data.interestOnEscrowFlag && data.startOfNextAccrualPeriod != null) {
      ctx.addIssue({
        code: 'custom',
        message: 'START_OF_NEXT_ACCRUAL_PERIOD can only be set when INTEREST_ON_ESCROW_FLAG is yes',
        path: ['startOfNextAccrualPeriod'],
      });
    }

    if (!data.interestOnEscrowFlag && data.flag1099Int != null) {
      ctx.addIssue({
        code: 'custom',
        message: '1099_INT_FLAG can only be set when INTEREST_ON_ESCROW_FLAG is yes',
        path: ['flag1099Int'],
      });
    }
  });

export type BulkDepositRow = z.infer<typeof BulkDepositRow>;

export const BULK_DEPOSIT_ROW_REQUIRED_FIELDS = Object.keys(BulkDepositRow.shape).filter(
  (key) => !BulkDepositRow.shape[key as keyof typeof BulkDepositRow.shape].isOptional(),
);
